import { Storage, EventBus } from '../Utils'

export default {
    data() {
        return {
            form: { email: "", password: "", confirmPassword: "", day: "", month: "", year: "", dateOfBirth: "" },
            emailError: false,
            passwordError: false,
            confirmPasswordError: "",
            birthdayError: "",
            emailErrors: [],
            passwordErrors: [],
            serviceError: false,
            DateOfBirthErrors: [],
            formValid: false,
        }
    },
    methods: {
        isValidform() {
            const { email, password, confirmPassword, day, month, year } = this.form;

            this.emailErrors = [];

            if (!this.validEmail(email)) {
                this.emailErrors.push('Valid email required.');
            }

            if (!this.emailErrors.length && 
                !this.passwordErrors.length && 
                !this.DateOfBirthErrors.length) {
                return true;
            }
            
            return false;
        },
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }
};